function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Descriptions, Divider, InputNumber, Radio, Alert, Tag, Upload } from 'antd';
import Common from "../includes/Common";
import { Upload as UploadIcon } from 'react-bootstrap-icons';
import { Container, Row, Col } from "react-bootstrap";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var SetSerologie = function SetSerologie(_ref) {
  var candidat = _ref.candidat,
    handler = _ref.handler,
    _ref$update = _ref.update,
    update = _ref$update === void 0 ? false : _ref$update;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormProcessing = _useState2[0],
    setIsFormProcessing = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    file = _useState6[0],
    setFile = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    widalTh = _useState8[0],
    setWidalTh = _useState8[1];
  var _useState9 = useState(0),
    _useState0 = _slicedToArray(_useState9, 2),
    widalTo = _useState0[0],
    setWidalTo = _useState0[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var props = {
    onRemove: function onRemove(file) {
      setFile(null);
    },
    beforeUpload: function beforeUpload(file) {
      setFile(file);
      return false;
    },
    accept: ".pdf",
    maxCount: 1
  };
  var handleThChange = function handleThChange(v) {
    setWidalTh(v);
  };
  var handleToChange = function handleToChange(v) {
    setWidalTo(v);
  };
  var onFinish = function onFinish(values) {
    setErrorMessage('');
    setIsFormProcessing(true);
    var formData = new FormData();
    formData.append("user_id", Common.currentUser.id);
    formData.append("customer_id", candidat.id);
    Object.entries(values).forEach(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];
      formData.append(key, value === undefined || value === '' || value === "null" || value === null ? '' : value);
    });

    /*formData.append("aghbs", values.aghbs);
    formData.append("srv", values.srv); 
    formData.append("syphilis", values.syphilis);   
    formData.append("crp", values.crp);
    formData.append("achcv", values.achcv); 
    let achcv_val = (values.achcv == "" || values.achcv == 'undefined') ? null : values.achcv;  
    formData.append("achcv", achcv_val);  
    formData.append("widal_th", values.widal_th); 
    formData.append("widal_to", values.widal_to); 
    formData.append("widal_comment_th", values.widal_comment_th);     
    formData.append("widal_comment_to", values.widal_comment_to);     */

    axios.post(Common.baseApiUrl + "setserologie", formData).then(function (response) {
      if (response.data.status == 200) {
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue");
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };
  useEffect(function () {
    if (update == true) {
      form.setFieldsValue({
        aghbs: candidat.laboratory_result.serologie != null ? candidat.laboratory_result.serologie.aghbs : "",
        srv: candidat.laboratory_result.serologie != null ? candidat.laboratory_result.serologie.srv : "",
        crp: candidat.laboratory_result.serologie != null ? candidat.laboratory_result.serologie.crp : "",
        achcv: candidat.laboratory_result.achcv != null ? parseInt(candidat.laboratory_result.serologie.achcv) : "",
        widal_th: candidat.laboratory_result.serologie != null ? candidat.laboratory_result.serologie.widal_th : "",
        widal_to: candidat.laboratory_result.serologie != null ? candidat.laboratory_result.serologie.widal_to : "",
        widal_comment_th: candidat.laboratory_result.serologie != null ? candidat.laboratory_result.serologie.widal_comment_th : "",
        widal_comment_to: candidat.laboratory_result.serologie != null ? candidat.laboratory_result.serologie.widal_comment_to : ""
      });
    }
    form.setFieldsValue({
      comment: ""
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: errorMessage,
          banner: true
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "AgHbs",
        name: "aghbs",
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "SRV",
        name: "srv",
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Syphilis",
        name: "syphilis",
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "CRP",
        name: "crp",
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "AchCV",
        name: "achcv",
        children: /*#__PURE__*/_jsxs(Radio.Group, {
          buttonStyle: "solid",
          children: [/*#__PURE__*/_jsx(Radio.Button, {
            value: 0,
            children: "NEGATIF"
          }), /*#__PURE__*/_jsx(Radio.Button, {
            value: 1,
            children: "POSITIF"
          })]
        })
      }), /*#__PURE__*/_jsxs("fieldset", {
        children: [/*#__PURE__*/_jsx("legend", {
          children: "WIDAL"
        }), /*#__PURE__*/_jsx(Form.Item, {
          label: "TH",
          name: "widal_th",
          children: /*#__PURE__*/_jsxs(Radio.Group, {
            onChange: handleThChange,
            buttonStyle: "solid",
            children: [/*#__PURE__*/_jsx(Radio.Button, {
              value: 0,
              children: "NEGATIF"
            }), /*#__PURE__*/_jsx(Radio.Button, {
              value: 1,
              children: "POSITIF"
            })]
          })
        }), /*#__PURE__*/_jsx(Form.Item, {
          label: "Si TH positif",
          name: "widal_comment_th",
          children: /*#__PURE__*/_jsxs(Radio.Group, {
            buttonStyle: "solid",
            children: [/*#__PURE__*/_jsx(Radio.Button, {
              value: "1/200",
              children: "1/200"
            }), /*#__PURE__*/_jsx(Radio.Button, {
              value: "1/400",
              children: "1/400"
            }), /*#__PURE__*/_jsx(Radio.Button, {
              value: "1/600",
              children: "1/600"
            })]
          })
        }), /*#__PURE__*/_jsx(Form.Item, {
          label: "TO",
          name: "widal_to",
          children: /*#__PURE__*/_jsxs(Radio.Group, {
            onChange: handleToChange,
            buttonStyle: "solid",
            children: [/*#__PURE__*/_jsx(Radio.Button, {
              value: 0,
              children: "NEGATIF"
            }), /*#__PURE__*/_jsx(Radio.Button, {
              value: 1,
              children: "POSITIF"
            })]
          })
        }), /*#__PURE__*/_jsx(Form.Item, {
          label: "Si TO positif",
          name: "widal_comment_to",
          children: /*#__PURE__*/_jsxs(Radio.Group, {
            buttonStyle: "solid",
            children: [/*#__PURE__*/_jsx(Radio.Button, {
              value: "1/200",
              children: "1/200"
            }), /*#__PURE__*/_jsx(Radio.Button, {
              value: "1/400",
              children: "1/400"
            }), /*#__PURE__*/_jsx(Radio.Button, {
              value: "1/600",
              children: "1/600"
            })]
          })
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          loading: isFormProcessing,
          htmlType: "submit",
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "VALIDER"
          })
        })
      })]
    })
  });
};
export default SetSerologie;